import { getUserLang } from '@mb/lib/i18n';
import { handleSystemErrorReport } from '@mb/lib/utils';
import axios from 'axios';
import { config } from '../../config';
export type base64File = {
  base64: string;
  file_name: string;
  size: number;
  type: string;
};
export const uploadSearchImage = async (
  value: string | null,
  file?: base64File,
) => {
  try {
    const configLang =
      typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : 'US';
    const userLang = getUserLang();
    const prefix = configLang === 'US' ? '' : `/${userLang}`;
    const payload = file != null ? file : { image_url: value };
    const body = {
      image: payload,
    };
    const { data } = await axios.post(
      prefix + config.endpoints.postImage,
      body,
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    if (data?.image_url) {
      window.dispatchEvent(
        new CustomEvent('newMatchesFileAdded', {
          detail: {
            image: data,
          },
        }),
      );
    }
    return { item: data };
  } catch (e) {
    console.log('Error uploadSearchImage:', e);
    const errorMessage = e.response.data.message;
    handleSystemErrorReport(
      `Error uploadSearchImage: ${errorMessage}`,
      'image_search',
    );
    return { errorMessage };
  }
};
